import {declintRu} from '@specials/utils';

export class DeclineUtils {
  static declineDays(days: number): string {
    return declintRu(days, ['день', 'дня', 'дней']);
  }
}
